import SlidePanel from './SlidePanel'
import { SlidePanelScrollContext } from './SlidePanel'

export { SlidePanelScrollContext }
export default SlidePanel